import React, { useEffect, useState } from 'react';
import Slider from './../common/components/slider/Slider';
import PastEventCard from '../common/components/events/pastEvent';
import './../styles/styles.css';

const Events = () => {
    const [eventSeries, setEventSeries] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`/api/events`)
            .then(res => {
                if (!res.ok) throw new Error("failed to fetch events");
                return res.json();
            })
            .then(data => {
                const publishedEvents = data.filter(e => e.published !== false);

                // sort newest first
                const sortedEvents = publishedEvents.sort(
                    (a, b) => new Date(b.startDate) - new Date(a.startDate)
                );

                // Event Series = 3 most recent
                const series = sortedEvents.slice(0, 3);
                const seriesIds = series.map(event => event.id);

                const formattedSeries = series.map(event => ([
                    event.name || "untitled event",
                    event.description || "",
                    event.startDate && event.endDate
                        ? `${new Date(event.startDate).toLocaleDateString()} – ${new Date(event.endDate).toLocaleDateString()}`
                        : event.startDate
                            ? new Date(event.startDate).toLocaleDateString()
                            : "",
                    null, // <-- image removed here
                    event.link || null
                ]));

                // Past Events = all other events
                const past = publishedEvents
                    .filter(event => !seriesIds.includes(event.id))
                    .sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

                setEventSeries(formattedSeries);
                setPastEvents(past);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setError("failed to load events");
                setLoading(false);
            });
    }, []);


    if (loading) {
        return <p style={{ padding: "4rem", textAlign: "center" }}>loading events...</p>;
    }

    if (error) {
        return <p style={{ padding: "4rem", textAlign: "center" }}>{error}</p>;
    }

    return (
        <div style={{ height: "100%", display: "block", margin: "0", overflow: "hidden" }}>
            {/* hero section */}
            <section style={{ paddingTop: '12%', paddingBottom: '5%', backgroundColor: '#B3E2D4' }}>
                <div className="container">
                    <div className="row pt-5">
                        <div className="col-lg-6 m-auto">
                            <h1>Events & <br />Educationals</h1>
                        </div>
                        <div className="col-lg-6 py-5">
                            <h4 style={{ fontFamily: 'nunito' }}>
                                we provide our community with access to informative panels,
                                educationals, workshops, inspirational speakers.
                            </h4>
                        </div>
                    </div>
                </div>
            </section>

            <br /><br /><br />

            {/* event series slider */}
            <div className="container">
                <h3>EVENT SERIES</h3>
                <div style={{ backgroundColor: '#F1EFE2', borderRadius: '20px', height: '450px' }}>
                    <div className="slider m-3" style={{ paddingTop: '50px' }}>
                        <Slider type="events" arr={eventSeries} />
                    </div>
                </div>
            </div>

            {/* past events */}
            <div className="marginTop5Footer">
                <div className="container">
                    <h3>A LOOK BACK</h3>
                    <h2>Past Events</h2>

                    <div className="row gx-4 gy-4">
                        {pastEvents.map(event => (
                            <PastEventCard
                                key={event.id}
                                image={event.image}
                                title={event.name}
                                desc={event.description}
                                link={event.link}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Events;
